import React from 'react';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import FullStatus from '../plans/FullStatus';

const AreaFullStatus = ({ status, trend, progress, startDate, endDate, className = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    return (
        <FullStatus
            label={t('Area Status')}
            status={status}
            trend={trend}
            progress={progress}
            startDate={startDate}
            endDate={endDate}
            className={className}
        />
    );
};

export default AreaFullStatus;
